import useSWR from 'swr';
import axios from 'axios';

const instance = axios.create({
  withCredentials: true
});

const fetcher = (url: string) => {
  return instance.get(url);
};

// Check if Okta is configured - if so, skip external auth (Okta handles auth)
const hasOktaCredentials = process.env.OKTA_CLIENT_ID && process.env.OKTA_CLIENT_SECRET && process.env.OKTA_ISSUER;

export const useAuth = () => {
  // Determine URL at module level to avoid conditional hooks
  // - Sites with Okta: pass null to skip fetch (auth handled by NextAuth)
  // - Sites without Okta: call external auth domain
  const url = hasOktaCredentials
    ? null // Skip fetch for Okta sites (prevents CORS errors)
    : process.env.USER_AUTH_DOMAIN
    ? `${process.env.USER_AUTH_DOMAIN}/me`
    : '/api/v1/users/me';

  return useSWR(url, fetcher);
};
